<template>
    <div :class="[
        'lms__user_workspaces_list_grid_item',
        isAccessedWorkspace ? 'lms__user_workspaces_list_grid_item--active' : ''
    ]">
        <div class="lms__user_workspaces_list_grid_item_content">
            <h2 class="lms__user_workspaces_list_grid_item_content_title">{{ workspaceName }}</h2>
            <div class="lms__user_workspaces_list_grid_item_content_roles">
                <template v-if="workspaceHasMasterAdminRole">
                    <component-badge-role :type="'second'" :role="'master_administrator'"></component-badge-role>
                </template>
                <component-badge-roles-list :roles="workspaceRoles"></component-badge-roles-list>
            </div>
            <div class="lms__user_workspaces_list_grid_item_content_actions">
                <component-button
                    :theme="isAccessedWorkspace ? 'default' : 'primary'"
                    :size="'full'"
                    :animate-loading="!isAccessedWorkspace"
                    :animate-loading-event-name="'access-workspace'"
                    :name="`lms-user-workspaces-list-grid-item-content-actions-button-${workspaceId}`"
                    @click="performWorkspace"
                >{{ isAccessedWorkspace ? 'Leave' : this.$t('lms.workspace.buttons.access') }}
                </component-button>
            </div>
        </div>
    </div>
</template>

<script>
import ComponentButton from '@/components/default/shared/ComponentButton'
import ComponentBadgeRole from '@/components/default/shared/ComponentBadgeRole'
import ComponentBadgeRolesList from '@/components/default/shared/ComponentBadgeRolesList'

export default {
  name: 'lms-user-workspaces-list-grid-item',
  components: { ComponentBadgeRolesList, ComponentBadgeRole, ComponentButton },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    isAccessedWorkspace () {
      return this.$store.getters.getAuthUserSecondStageTokenDataWorkspaceId === this.workspaceId
    },
    workspaceId () {
      return this.item.id
    },
    workspaceName () {
      return this.item.name
    },
    workspaceStatus () {
      return this.item.status
    },
    workspaceCustomerName () {
      return this.item.customerName
    },
    workspaceRoles () {
      return this.item.roles
    },
    workspaceHasMasterAdminRole () {
      return this.item.hasCustomerRole
    }
  },
  methods: {
    performWorkspace () {
      if (this.isAccessedWorkspace) {
        this.logoutWorkspace()
      } else {
        this.accessWorkspace()
      }
    },
    accessWorkspace () {
      this.$store.dispatch('authUserLoginSSOWorkspace', this.workspaceId).then(() => {
        this.$router.push({ name: 'default' })
        this.$eventBus.$emit('stop-access-workspace')
      })
    },
    logoutWorkspace () {
      this.$store.dispatch('authUserLogoutSecondStage')
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/user/workspaces/_lmsuserworkspacelistgriditem.scss";
</style>
